var render, staticRenderFns
import script from "./member_list.vue?vue&type=script&lang=js"
export * from "./member_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acd21b64')) {
      api.createRecord('acd21b64', component.options)
    } else {
      api.reload('acd21b64', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/queue_manage/form/member_list.vue"
export default component.exports